/**
 * Legacy hardcoded conditions for Primal TCG.
 * Used as fallback when no game config is available.
 */
var LEGACY_CONDITIONS = [
  { value: 'NM', label: 'Near Mint', foilOnly: false },
  { value: 'NMF', label: 'Near Mint Foil', foilOnly: true },
  { value: 'LP', label: 'Lightly Played', foilOnly: false },
  { value: 'LPF', label: 'Lightly Played Foil', foilOnly: true },
  { value: 'MP', label: 'Moderately Played', foilOnly: false },
  { value: 'MPF', label: 'Moderately Played Foil', foilOnly: true },
  { value: 'HP', label: 'Heavily Played', foilOnly: false },
  { value: 'Damaged', label: 'Damaged', foilOnly: false },
];

var LEGACY_NO_FOIL_RARITIES = ['Super Rare', 'Secret Rare', 'Legendary Rare'];

/**
 * Build a conditions list from game config.
 * Each game condition has: { value, label, hasFoil }
 * For conditions with hasFoil: true, we add both base + foil versions.
 * Foil versions are filtered out if the card's rarity is in noFoilRarities.
 *
 * @param {Array|null} gameConditions - Game's conditions array [{value, label, hasFoil}]
 * @param {Array|null} noFoilRarities - Rarity names that cannot be foil
 * @param {string|null} cardRarity - The card's rarity (to filter foil options)
 * @returns {Array} Conditions list with {value, label, foilOnly}
 */
export function buildConditionsList(gameConditions, noFoilRarities, cardRarity) {
  // Fallback to legacy
  if (!gameConditions || gameConditions.length === 0) {
    var noFoil = noFoilRarities || LEGACY_NO_FOIL_RARITIES;
    var isFoilBlocked = cardRarity && noFoil.indexOf(cardRarity) !== -1;
    if (isFoilBlocked) {
      return LEGACY_CONDITIONS.filter(function(c) { return !c.foilOnly; });
    }
    return LEGACY_CONDITIONS;
  }

  var noFoilList = noFoilRarities || [];
  var isFoilBlocked = cardRarity && noFoilList.indexOf(cardRarity) !== -1;

  var result = [];
  for (var i = 0; i < gameConditions.length; i++) {
    var cond = gameConditions[i];
    // Always add base condition
    result.push({ value: cond.value, label: cond.label, foilOnly: false });
    // Add foil variant if hasFoil and rarity allows it
    if (cond.hasFoil && !isFoilBlocked) {
      result.push({ value: cond.value + 'F', label: cond.label + ' Foil', foilOnly: true });
    }
  }
  return result;
}

export { LEGACY_CONDITIONS, LEGACY_NO_FOIL_RARITIES };
